import * as React from 'react';
import styled from 'styled-components';
import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@material-ui/core/Drawer';
import { Uds } from '../../types';

const isTestEnv = process.env.NODE_ENV === 'test';

export type DrawerProps = Uds<
  Omit<MuiDrawerProps, 'css'> & {
    width?: string;
  }
>;

export const Drawer: React.FC<React.PropsWithChildren<DrawerProps>> = ({ dataTest, ...props }) => (
  <StyledDrawer data-test={dataTest} disableEnforceFocus={isTestEnv ? true : undefined} {...props} />
);

export default Drawer;

const StyledDrawer = styled(MuiDrawer)<Omit<DrawerProps, 'data-test'>>`
  .MuiDrawer-paper {
    width: ${(props) => props.width};
  }
`;
